import { DocumentPart } from "../../api/models";
import { FileLocation } from "./FileLocationProvider";

export function mapDocumentPartsToFileLocations(documentParts: DocumentPart[] | null | undefined): FileLocation[] {
  if (!Array.isArray(documentParts)) {
    return [];
  }
  return documentParts.map<FileLocation>((df) => ({
    key: df.driveItemId,
    text: (df.name ?? "").replace(/\.docx$/i, ""),
    path: df.path,
    iconName: df.folder ? "fabricFolder" : "wordDocument",
    document: df,
  }));
}
